import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_TIME_SLOTS } from 'pages/SchedulePage/gqlSchemes/getTimeSlots';
import {
  formatISO,
  parse,
  isToday,
  endOfToday,
  endOfDay,
  startOfDay,
  parseISO,
} from 'date-fns';
import { forEach } from 'ramda';

function useTimeSlotsRequest(
  selectedDate,
  duration = 30,
  userId,
  reservationModeId,
  roomId
) {
  const [
    getTimeSlots,
    { called, loading, error, data: timeSlots },
  ] = useLazyQuery(GET_TIME_SLOTS);

  useEffect(() => {
    if (Array.isArray(selectedDate)) {
      getTimeSlots({
        variables: {
          filter: {
            duration,
            periodStartDate: isToday(selectedDate[0])
              ? formatISO(new Date())
              : formatISO(startOfDay(selectedDate[0])),
            periodEndDate: formatISO(endOfDay(selectedDate[1])),
            user: userId,
            reservationModeId,
            roomId,
          },
        },
      });
    } else {
      getTimeSlots({
        variables: {
          filter: {
            duration,
            periodStartDate: isToday(selectedDate)
              ? formatISO(new Date())
              : formatISO(startOfDay(selectedDate)),
            periodEndDate: isToday(selectedDate)
              ? formatISO(endOfToday())
              : formatISO(endOfDay(selectedDate)),
            user: userId,
            reservationModeId,
            roomId,
          },
        },
      });
    }
  }, [selectedDate, getTimeSlots, duration]);

  if (error) {
    console.log('Get time slots error:', error);
  }

  const slots = [];
  const cTimeSlots = timeSlots?.schedule?.timeslotMany?.items || [];

  if (cTimeSlots) {
    forEach((item) => {
      const determineFormat = (timeStr) => {
        const fractionPattern = /\d{2}:\d{2}:\d{2}\.\d+[+-]\d{2}:\d{2}/;
        return fractionPattern.test(timeStr)
          ? 'HH:mm:ss.SSSSSSXXX'
          : 'HH:mm:ssXXX';
      };

      const startTimeFormat = determineFormat(item.startTime);
      const endTimeFormat = determineFormat(item.endTime);

      const startTime = Array.isArray(selectedDate)
        ? parse(item.startTime, startTimeFormat, selectedDate[0])
        : parse(item.startTime, startTimeFormat, selectedDate);
      const endTime = Array.isArray(selectedDate)
        ? parse(item.endTime, endTimeFormat, selectedDate[0])
        : parse(item.endTime, endTimeFormat, selectedDate);

      const formattedToDate = { startTime, endTime };
      slots.push(formattedToDate);
    }, cTimeSlots);
  }

  return { loading, timeSlots: cTimeSlots, slots };
}

export default useTimeSlotsRequest;
